import { Link } from '../../../../../../../Resource/Types';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { observer } from 'mobx-react';
import UploadState from './UploadState';
import { T } from '../../../../../../../Translations';
import { UploadImageStore } from '../UploadImageStore';
import { useState } from 'react';
import { Maybe } from 'maybeasy';
import { useLinks } from './useLinks';

interface Props {
  uploadImageStore: UploadImageStore;
  links: ReadonlyArray<Link>;
}

function S3ImageUpload({ uploadImageStore, links }: Props) {
  const { getLink } = useLinks(links);
  const [previewUrl, setPreviewUrl] = useState<Maybe<Link>>(getLink('learning-collection-logo'));

  return getLink('direct-upload')
    .map((uploadLink) => (
      <>
        <h1 className="mb-2 text-sm font-semibold text-gray-800">
          <T kind="Organization Logo" />
        </h1>
        <UploadState
          store={uploadImageStore}
          uploadLink={uploadLink}
          previewUrl={previewUrl}
          setPreviewUrl={setPreviewUrl}
        />
      </>
    ))
    .getOrElse(emptyFragment);
}

export default observer(S3ImageUpload);
